import React, { useEffect } from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { H1, Text } from '@amzn/stencil-react-components/text';
import { STAGE } from '../constants/context';
import {
  FCMENU_BETA_URL_EXTERNAL,
  FCMENU_BETA_URL_INTERNAL,
  FCMENU_DEV_TOKEN_INTERNAL,
  FCMENU_PROD_URL_EXTERNAL,
  FCMENU_PROD_URL_INTERNAL,
} from '../constants/loginConfiguration';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom'
import { useQuery } from 'src/hooks';

// For CORP aka Internal
const internalRedirectUrls: Record<string, string> = {
  Beta: FCMENU_BETA_URL_INTERNAL,
  Gamma: FCMENU_BETA_URL_INTERNAL,
  Prod: FCMENU_PROD_URL_INTERNAL,
  Default: `/?fcmenu-sensitive=${FCMENU_DEV_TOKEN_INTERNAL}`,
};

// For MOC aka External
const externalRedirectUrls: Record<string, string> = {
  Beta: FCMENU_BETA_URL_EXTERNAL,
  Gamma: FCMENU_BETA_URL_EXTERNAL,
  Prod: FCMENU_PROD_URL_EXTERNAL,
  Default: '/?loginType=moc',
};

export const Login = ({}) => {
  const { t, i18n } = useTranslation();
  const query = useQuery();
  const [_searchParams, setSearchParams] = useSearchParams();

  /**
   * The sole purpose is for Canada specfic sites that use French,
   * but will work for any site that supports a different language
   * by changing the locale in the URL query param.
   * 
   * Example: https://prod.pak.qubit.amazon.dev/?language=fr-CA
   */
  useEffect(() => {
    if (query.get('language')) {
      const locale: string = query.get('language') || 'en-US';
      i18n.changeLanguage(locale);
    }
  }, []);

  const redirectToFCMenu = () => {
    let fcMenuUrl = '';

    if (query.get('loginType')?.toLowerCase() === 'moc') {
      fcMenuUrl = externalRedirectUrls[STAGE] || externalRedirectUrls['Default']; // MOC
    } else {
      fcMenuUrl = internalRedirectUrls[STAGE] || internalRedirectUrls['Default']; // CORP
    }

    window.location.href = fcMenuUrl;
  };

  return (
    <div>
      <H1>PAK {t('login')}</H1>
      <br></br>
      <Text fontWeight="medium">{t('loginDescriptionTitle')}</Text>
      <ol>
        <li>
          <Text fontWeight="light">{t('loginStep1')}</Text>
        </li>
        <li>
          <Text fontWeight="light">{t('loginStep2')}</Text>
        </li>
        <li>
          <Text fontWeight="light">
            {t('loginStep3Part1')} &rarr; {t('loginStep3Part2')} &rarr; {t('loginStep3Part3')}
          </Text>
        </li>
      </ol>
      <br></br>
      <Button onClick={redirectToFCMenu}>{t('loginFCMenuText')}</Button>
    </div>
  );
};
